import React, { useEffect, useState } from 'react';
import Loader from './Loader';
import { Container } from 'react-bootstrap';
import Table from './Table';
import styles from './EditFormsPreConsult.module.scss';
import ModalCopyLink from './ModalCopyLink';
import { alertModal } from '../utils/modalController';
import { useNavigate } from 'react-router-dom';
import { fetchAuth } from '../utils/fetchAuth';

interface Props {
    pacienteId: string;
    consultaId?: string;
}

const apiUrl = process.env.REACT_APP_API_URL || '';

const EditFormsPreConsult: React.FC<Props> = ({ pacienteId, consultaId }) => {
    const [formularios, setFormularios] = useState<FormResponse[]>([]);
    const [selectedForm, setSelectedForm] = useState<FormResponse | null>(null);
    const [showModalLink, setShowModalLink] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    useEffect(() => {
        const buscarFormularios = async () => {
            try {
                const response = await fetchAuth(`${apiUrl}/consultorio/consultations/${consultaId}/forms`);
                if (!response.ok) throw new Error('Erro ao buscar formulários');
                const data = await response.json();
                setFormularios(data);
            } catch (e) {
                console.error('Erro ao buscar formulários:', e);
                alertModal('Erro ao buscar formulários: ' + e);
            } finally {
                setLoading(false);
            }
        };

        buscarFormularios();
    }, [pacienteId, consultaId]);

    if (loading) return <Loader />;

    return (
        <>
            <Container>
                <h5 className="mb-3">Questionários Pré-Consulta</h5>
                {
                    formularios.length > 0 ? (<Table
                        headings={['Titulo', 'Respondido em']}
                        data={formularios.flatMap((form) =>
                            form.responses.map((response) => [
                                <a href='#' className={styles["link"]} onClick={(e) => {
                                    e.preventDefault();
                                    if (!form.answered_at) {
                                        setSelectedForm(form);
                                        setShowModalLink(true);
                                    } else {
                                        setSelectedForm(null);
                                        navigate({
                                            pathname: `/consultorio/pacientes/${pacienteId}/formularios/${form.id}`,
                                            search: `?consulta=${consultaId}&response=${response.id}`,
                                        });
                                    }
                                }}>
                                    {form.title}
                                </a>,
                                form.answered_at ? new Date(form.answered_at).toLocaleDateString('pt-BR', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                }) : '---'
                            ]),
                        )}
                    />) : (<p>Nenhum questionário foi enviado</p>)
                }
            </Container>
            <ModalCopyLink
                show={showModalLink}
                onClose={() => {
                    setShowModalLink(false);
                    setSelectedForm(null);
                }}
                urlPath={`formularios/${selectedForm?.id}`}
            />
        </>
    );
};

export default EditFormsPreConsult;
